import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
// Solana removed

function formatNumber(number) {
  const parsedNumber = parseFloat(number);

  if (isNaN(parsedNumber)) return "0.0";

  // Convert to string without formatting
  const plainStr = parsedNumber.toString().replace('.', '').replace('-', '');

  // If more than 10 digits, return in exponential notation
  if (plainStr.length > 17) {
    return parsedNumber.toExponential(2); // e.g., 1.23e+10
  }

  // Otherwise, return formatted normally
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(parsedNumber);
}

function formatPrice(value) {
  const n = Number(value);
  if (!isFinite(n)) return '0.00';
  if (n === 0) return '0.00';
  const abs = Math.abs(n);
  if (abs >= 1) {
    return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  if (abs < 1e-8) {
    return n.toExponential(2);
  }
  let decimals = 2;
  if (abs >= 1e-1) decimals = 3;
  else if (abs >= 1e-2) decimals = 4;
  else if (abs >= 1e-3) decimals = 5;
  else if (abs >= 1e-4) decimals = 6;
  else if (abs >= 1e-5) decimals = 7;
  else decimals = 8;
  return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}


function Token({ token }) {
  const { chain } = useParams();

  const [isFallbackImage, setIsFallbackImage] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [tokenNotData,settokenNotData] = useState(null)
  const fallbackUrl = "https://dd.dexscreener.com/ds-data/tokens/ethereum/0xc9bca88b04581699fab5aa276ccaff7df957cbbf.png?size=lg&key=758833";

  const handleImageError = (e) => {
    // First fallback: Dexscreener fallback
    if (!e.target.dataset.fallback || e.target.dataset.fallback === 'first') {
      e.target.onerror = null;
      e.target.src = fallbackUrl;
      e.target.dataset.fallback = 'second';
      setIsFallbackImage(true);
      settokenNotData(true)
      return;
    }
    // Second fallback: no special handling per chain
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <Link  to={`/${chain}/token/${token.address}`}>
      <div className='flex items-center justify-between font-[600]    border-b border-white/5 hover:bg-[#5b607610]  py-[16px] rounded-lg relative px-5 mx-4'>
        <div className='flex gap-2 items-center kanit-light relative'>
          <div className='relative'>
            <img
              alt={token.name}
              onError={handleImageError}
              onLoad={handleImageLoad}
              className='w-5 h-5 sm:w-6 sm:h-6 rounded-full'
              src={(token.logo && String(token.logo).trim() !== '') ? token.logo : fallbackUrl}
            />
            {/* Show checkmark only if image loaded successfully and did not fail */}
            { tokenNotData !== true && imageLoaded && !isFallbackImage  && 
                  (token.address ==="0xC9bCa88B04581699fAb5aa276CCafF7Df957cbbf" ||
                     token.address === "0xD6175692026BcD7Cb12A515e39cF0256eF35cb86" ||
                     token.address === "0x6304563F6639c077B519209f38611C0F67D6f10d" ||
                     token.address === "0xd81E97027c21366Ead8E37428b3c033E95A7ADC2" ||
                     token.address === "0x6A064c1B4A0432c5d7Df441759E4E256F21af8BA" ||
                     token.address === "0x7b20798866Fe3320EC5395e9978a3C98195c7c36" ||
                     token.address === "0xE5f9f6d8a6fDa962cC7448fE903dbae89deA4eD8" ||
                     token.address ==="0x6F0D7bA19646D0eF82bf8f78f3A7456aD5B9481F" ||
                     token.address === "0xdAC17F958D2ee523a2206206994597C13D831ec7" ||
                     token.address === "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"

        
                  )? 
                  (<img src='/checkmark.png' className={`absolute  bottom-4 left-[14px]  border-[#0e1018]  w-2 h-2 sm:w-4 sm:h-4 rounded-full flex items-center justify-center hidden`} />)
                  :
                  (tokenNotData !== true && <img src='/checkmarkblue.png' className='absolute bottom-4 left-[14px]  border-[#0e1018]  w-2 h-2 sm:w-4 sm:h-4 rounded-full flex items-center justify-center hidden' />)
          }
          </div>
          <p className='text-[13px] sm:text-[15px] font-[500] inter-400 text-gray-100'>{token.symbol}</p>
          <p className='text-gray-500 text-[13px] ml-1 font-[400] hidden sm:block'>{token.name}</p>
        </div>
        <div className='flex gap-[3px] sm:gap-[40px] mr-6 sm:mr-12 md:gap-[64px] lg:mr-0 lg:gap-[95px] xl:gap-[116px] text-[9px] sm:text-[14px] inter-500 font-[500] text-white/90  items-center'>
          <span className='w-[53px] text-end flex flex-col'>
            <span className='flex items-center justify-end'>
              { parseFloat(token.change24h) > 0 ?  
                  <img alt="Uptrend icon" src='/uptrend.png' className='w-[6px] h-[5px] mx-1' /> 
              :
              <div className='w-6 h-2' /> }
              <span className='satoshi-400 text-[11px] pt-[1px]'>$</span>{formatPrice(token.price)}
            </span>
          </span>

          <span
            className={`w-[53px] text- text-end  ${
              parseFloat(token.change24h) >= 0 ? 'text-emerald-300' : 'text-rose-400'
            }`}
          >
            {token.change24h != null ? token.change24h+'%' : '-'}
          </span>

          <span className='w-[53px] text-end hidden sm:block'><span className='satoshi-400'>$</span>{formatNumber(token.volume)}</span>
          <span className='w-[53px] text-end '><span className='satoshi-400'>$</span>{formatNumber(token.fdv)}</span>

          <span
            className={`w-[53px] text-end hidden lg:block ${
              parseFloat(token.apy) >= 0 ? 'text-emerald-300' : 'text-rose-400'
            }`}
          >
            {Math.round(token.apy)=== 0 ? '-' : Math.round(token.apy) + `%`}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default Token;
